import React from "react";
import { Truck, User2, Wallet, RotateCcw, CreditCard, X } from "lucide-react";

const TransactionModal = ({
  isOpen,
  onClose,
  handleClick,
  setTab,
  mode = "inline",
}) => {
  if (!isOpen) return null;

  const transactionTypes = [
    // {
    //   title: "Material Purchase",
    //   key: "material",
    //   icon: <Truck className="w-5 h-5" />,
    // },
    {
      title: "Worker's Payment",
      key: "worker",
      icon: <User2 className="w-5 h-5" />,
    },
    {
      title: "General Payments",
      key: "other",
      icon: <Wallet className="w-5 h-5" />,
    },
    {
      title: "Add Refund",
      key: "refund",
      icon: <RotateCcw className="w-5 h-5" />,
    },
    {
      title: "Received",
      key: "receive",
      icon: <CreditCard className="w-5 h-5" />,
    },
  ];

  const handleTransactionClick = (transactionKey) => {
    onClose();
    handleClick(transactionKey);
  };

  const panel = (
    <div className="bg-white rounded-xl border border-gray-200 w-[280px] sm:w-[320px] shadow-lg p-3 relative">
      <button
        onClick={onClose}
        className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
      >
        <X className="w-5 h-5" />
      </button>
      <h2 className="text-base font-semibold mb-3">Add New Transaction</h2>
      <div className="flex flex-col gap-2">
        {transactionTypes.map((type) => (
          <button
            key={type.title}
            onClick={() => handleTransactionClick(type.key)}
            className="flex items-center gap-2.5 p-2.5 rounded-md bg-purple-50 hover:bg-purple-100 transition-colors duration-200 w-full text-left"
          >
            <span className="text-purple-600 [&>svg]:w-4 [&>svg]:h-4">
              {type.icon}
            </span>
            <span className="text-purple-900 text-sm">{type.title}</span>
          </button>
        ))}
      </div>
    </div>
  );

  if (mode === "inline") {
    return panel;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30 backdrop-blur-sm">
      {panel}
    </div>
  );
};

export default TransactionModal;
